import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {IFormHistory} from "../../models/form-history-interface";
import {BaseForm} from "../../models/base-form";
import Helpers from "../../utils/helpers";

@Injectable()
export class SendFileFormControllerService implements IFormHistory {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getHistoryPage(serviceId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/sendfile/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  public getSendFileForm(serviceId: string, reusable: boolean): Observable<BaseForm> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/sendfile?reusable=" + reusable) as Observable<BaseForm>;
  }

  public createSendFileForm(serviceId: string, form: BaseForm): Observable<BaseForm> {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/sendfile", body) as Observable<BaseForm>;
  }

  public saveSendFileForm(form: BaseForm) {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.put(this.baseUrl + "sendfile/" + form.id, body, {responseType: "text"});
  }

  public activateSendFileForm(formId: string, active: boolean) {
    return this.http.put(this.baseUrl + "sendfile/activate/" + formId + "/" + active, null, {responseType: "text"});
  }

  public getHistory(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/sendfile/history") as Observable<any[]>;
  }

  // Get form schema for preview only (GET request)
  public getFormSchemaForRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/sendfile/history/" + revisionNumber + "/schema") as Observable<any>;
  }

  // Revert form to a specific revision (PUT request - triggers cleanup of orphaned relations)
  public revertFormToRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.put(this.baseUrl + "service/" + serviceId + "/sendfile/history/" + revisionNumber, null, {responseType: "text"}) as Observable<any>;
  }

}
